import { setUrl, setUrlWithParams } from "@/services/endpoints/endpoint-helper.ts";

const MEASURE_ENDPOINTS = {
    ADD_MEASURE_TYPE: (projectId: string) => setUrl(`/measures/project/${projectId}/types`),
    GET_PROJECT_MEASURE_TYPES: (projectId: string) => setUrl(`/measures/project/${projectId}/types`),
    UPDATE_MEASURE_TYPES: (projectId: string) => setUrl(`/measures/project/${projectId}/types`),
    DELETE_MEASURE_TYPES: (projectId: string) => setUrl(`/measures/project/${projectId}/types`),
    DELETE_MEASURE_FROM_MEASURE_TYPES_AND_STOREY: (projectId: string, storeyId: string) => setUrl(`/measures/project/${projectId}/storey/${storeyId}/types`),

    GET_PROJECT_MEASURES: (projectId: string) => setUrl(`/measures/project/${projectId}`),
    GET_REPRESENTATIONS: () => setUrl(`/measures/representations`),

    UPDATE_PROJECT_MEASURES_FROM_MEASURES_TYPES: (projectId: string, excludeStoreyIds: string[]) => setUrlWithParams(`/measures/project/${projectId}`, { excludeStoreyIds: excludeStoreyIds }),
    UPDATE_STOREY_MEASURES: (storeyId: string) => setUrl(`/measures/storey/${storeyId}`),
    UPDATE_STOREY_MEASURES_FROM_DETECTION: (
        projectId: string,
        storeyId: string,
        fileRevisionId: string,
        taskId: string
    ) => setUrl(`/measures/project/${projectId}/storey/${storeyId}/fileRevision/${fileRevisionId}/task/${taskId}/fromDetection`),

    COPY_STOREY_MEASURES: (storeyId: string, storeyFromId: string) => setUrl(`/measures/storey/${storeyId}/copyFrom/${storeyFromId}`)
}

export default MEASURE_ENDPOINTS;